import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9sxagnm95: FaireBrandEntity = {
  token: "b_a9sxagnm95",
  type: "brand",
  name: "Forget Me Not Candle",
  avatarUrl:
    "https://cdn.faire.com/fastly/1bb35f3bf369ce4ddeab27ca14e00ae6628a21e2abb3b337169541b590f26cd6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/49474a403adeeee2b60878b4557d84fc97e11ed894d21499bc5353df90888956.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1bb35f3bf369ce4ddeab27ca14e00ae6628a21e2abb3b337169541b590f26cd6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/49474a403adeeee2b60878b4557d84fc97e11ed894d21499bc5353df90888956.png",
  location: "Chattanooga, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 32,
  isInsider: true,
  description:
    "Curated in Chattanooga, TN with 100% soy wax for an eco-friendly clean burn. We use lead-free cotton wicks and premium fragrance oils infused with essential oils. Our candles are vegan, cruelty-free, phthalate-free, and petroleum-free.\n\nOur soy wax products were born + thrive from a desire to gift luxurious fragrance that is naturally derived and eco-friendly. FMN Candle Co. uses only the purest of soy bean wax + quality fragrance + essential oils for a clean burn throughout the entire life of the candle. All of our products are 100% handmade with fragrance oils from around the globe and thoughtfully packaged in our space, for yours.\n\nFMN candles embrace a clean and simple aesthetic specifically to suit any décor or personality.\n\nQuestions? Connect with us on Social Media for updates, answered curiosities, and exclusive sales!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:19.581Z",
    importedBy: "entity-db-cli",
  },
};
